import type { TFunction } from "i18next";

import createDockPageRegistry, { type DockPageMeta } from "~/components/dock/dockPageRegistry";

const createRealPages = (t: TFunction<"common">): DockPageMeta[] => [
	{
		id: "forecasts",
		path: "/forecast/forecasts",
		routePattern: "forecasts/*",
		title: t("dock.pages.forecast.forecasts")
	},
	{
		id: "setup-assumptions",
		path: "/forecast/setup/assumptions",
		routePattern: "setup/assumptions/*",
		title: t("dock.pages.forecast.setupAssumptions")
	}
];

const createScopingPages = (t: TFunction<"common">): DockPageMeta[] => [
	{
		hideRibbon: true,
		id: "dashboard",
		path: "/forecast/dashboard",
		routePattern: "dashboard/*",
		title: t("dock.pages.forecast.dashboard")
	},
	{
		id: "forecasting",
		path: "/forecast/forecasting",
		routePattern: "forecasting/*",
		title: t("dock.pages.forecast.forecasting")
	},
	{
		id: "weekly",
		path: "/forecast/weekly",
		routePattern: "weekly/*",
		title: t("dock.pages.forecast.weekly")
	},
	{
		id: "parameters",
		path: "/forecast/parameters",
		routePattern: "parameters/*",
		title: t("dock.pages.forecast.parameters")
	},
	{
		id: "data-management-items",
		path: "/forecast/data-management/items",
		routePattern: "data-management/*",
		title: t("dock.pages.forecast.dataManagementItems")
	},
	{
		id: "data-management-programs",
		path: "/forecast/data-management/programs",
		routePattern: "data-management/*",
		title: t("dock.pages.forecast.dataManagementPrograms")
	},
	{
		id: "data-management-locations",
		path: "/forecast/data-management/locations",
		routePattern: "data-management/*",
		title: t("dock.pages.forecast.dataManagementLocations")
	},
	{
		id: "settings",
		path: "/forecast/settings",
		routePattern: "settings/*",
		title: t("dock.pages.forecast.settings")
	}
];

const createForecastDockPageRegistry = (t: TFunction<"common">, defaultPageId: string, showScopingUI: boolean) =>
	createDockPageRegistry(
		showScopingUI ? [...createRealPages(t), ...createScopingPages(t)] : createRealPages(t),
		defaultPageId
	);

export default createForecastDockPageRegistry;
